<template>
  <div class="wrapper">
    <div class="main">
      <transition name="fade">
        <div v-if="isShowContents" class="main__inner">
          <div class="card card--image">
            <div class="card__image">
              <img class="card__image__img" src="../assets/cover_image.png" alt="TVRコンピレーション ジャケット" />
            </div>
          </div>

          <div class="card card-white">
            <div class="card__inner">
              <div class="info">
                <h2>TVR Compilation Vol.1</h2>
                <p>2019年10月27日(日) 東京流通センター（TRC）</p>
                <p>2019 M3秋 第一展示場I-01bにて頒布</p>
                <p>販売価格：1000円</p>
              </div>
              <div class="tracklist">
                <h3>Tracklist</h3>
                <ul>
                  <template v-for="(item,index) in notes">
                    <li :key="index">
                      <p>{{`${index+1}.`}} {{item.title}}</p>
                    </li>
                  </template>
                </ul>
              </div>
              <iframe
                width="100%"
                height="166"
                scrolling="no"
                frameborder="no"
                allow="autoplay"
                src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/694749289&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"
              ></iframe>

              <div class="liner-notes">
                <h2>Special Liner Notes</h2>
                <LinerNotes />
                <h3>written by Stones Taro</h3>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="profile">
              <h2>T V R</h2>
              <P>Indpendent music label in Asia.</P>
              <P>
                <a
                  href="https://twitter.com/topvaluerec_jp"
                  target="_blank"
                  rel="noopener"
                >@topvaluerec_jp</a>
              </P>
              <p>
                bandcamp💿
                <a
                  href="http://goo.gl/iqyGRF"
                  target="_blank"
                  rel="noopener"
                >http://goo.gl/iqyGRF</a>
              </p>
              <p>
                SoundCloud🌩
                <a
                  href="http://goo.gl/HQQXYe"
                  target="_blank"
                  rel="noopener"
                >http://goo.gl/HQQXYe</a>
              </p>
              <p>
                Instagram📼📷🎨
                <a
                  href="http://goo.gl/nCKCoc"
                  target="_blank"
                  rel="noopener"
                >http://goo.gl/nCKCoc</a>
              </p>
            </div>
          </div>

          <div class="card">
            <iframe
              width="100%"
              height="450"
              scrolling="no"
              frameborder="no"
              allow="autoplay"
              src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/users/201315099&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
            />
          </div>
          <p class="copyright" @click="handleClickCounter">Copyright 2019 T V R</p>
        </div>
      </transition>
    </div>
    <div :style="styleObject" class="bg">
      <transition name="fade">
        <h1 v-if="isShowContents" class="title" @click="handleClickCounter">
          <img src="../assets/logo.png" alt="TVR" />
        </h1>
      </transition>
    </div>
  </div>
</template>

<script>
import LinerNotes from '../components/LinerNotes'
import NOTES from '../const/notes'
export default {
  name: 'Main',
  components: {
    LinerNotes
  },
  data() {
    return {
      notes: NOTES,
      isShowContents: false,
      sepiaBg: true,
      count: 0,
      countTimer: null,
      hue: 0
    }
  },
  computed: {
    styleObject() {
      return {
        backgroundImage: 'url(' + require('@/assets/bg_image.png') + ')',
        filter: `sepia(${this.sepiaBg ? 80 : 0}%) hue-rotate(${this.hue}deg)`,
        // 画面が表示されていない場合、アニメーションを切る
        'transition-duration':
          document.visibilityState === 'visible' ? '10s' : '0s'
      }
    }
  },
  mounted() {
    /* const randnum = 1 + Math.floor(Math.random() * 5)
    this.hue = randnum * 90 */

    setTimeout(() => {
      this.isShowContents = true
      this.sepiaBg = false
    }, 500)
    // 60000ms 1分ごとに1カウント
    this.countTimer = setInterval(() => {
      this.incrementCount()
    }, 60000)
  },
  destroyed() {
    clearInterval(this.countTimer)
  },
  methods: {
    handleClickCounter() {
      this.incrementCount()
    },
    incrementCount() {
      // 3カウントで色を変更(0,1,2)
      if (this.count >= 2) {
        this.count = 0
        this.incrementHue()
      } else {
        this.count++
      }
    },
    incrementHue() {
      if (this.hue >= 270) {
        this.hue = 0
      } else {
        this.hue += 90
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  position: relative;
}

.main {
  height: 100%;
  padding: 340px 0 120px;
  box-sizing: border-box;

  @media screen and (max-width: 768px) {
    padding: 240px 0 120px;
  }
}

.main__inner {
  z-index: 1;
  position: relative;
  pointer-events: none;
}

.title {
  width: 140px;
  margin: 110px auto;
  position: relative;
  z-index: 1;
  border-radius: 50%;
  overflow: hidden;
  background: #000;

  @media screen and (max-width: 768px) {
    margin: 60px auto;
    width: 130px;
  }

  > img {
    width: 100%;
    height: auto;
    vertical-align: top;
    border-radius: 50%;
  }
}

.bg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  transition: filter 10s ease-out;
}

.card {
  pointer-events: auto;
  background: #e5e5e5cf;
  padding: 40px;
  box-sizing: border-box;
  margin: 0 auto;
  height: 100%;
  width: calc(100% - 80px);
  max-width: 1200px;

  & + & {
    margin-top: 80px;

    @media screen and (max-width: 768px) {
      margin-top: 60px;
    }
  }

  @media screen and (max-width: 768px) {
    width: calc(100% - 25px);
    padding: 20px;
  }
}

.card--image {
  max-width: 640px;
}

.card__image {
  .card__image__img {
    width: 100%;
    vertical-align: top;
  }
}

.card-white {
  background: #fff;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
}

.info {
  font-size: 15px;
  line-height: 1.6;
  font-weight: bold;
  text-align: left;
  margin: 0 0 15px;
  color: #333;
  > h2 {
    font-size: 24px;
    line-height: 1;
    margin-bottom: 6px;
    @media screen and (max-width: 768px) {
      font-size: 19px;
    }
  }
  @media screen and (max-width: 768px) {
    font-size: 13px;
    margin: 0 0 10px;
  }
}

.tracklist {
  font-size: 15px;
  line-height: 1.6;
  font-weight: bold;
  text-align: left;
  margin: 0 0 30px;
  color: #333;
  h3 {
    font-size: 14px;
    margin-bottom: 0;
    margin-top: 0;
  }
  ul {
    padding: 0;
    list-style-type: none;
    margin: 0;
    font-size: 14px;
    padding-left: 5px;
    font-weight: normal;
  }
}

.liner-notes {
  margin-top: 60px;
  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }

  > h2 {
    font-size: 24px;
    color: #555;
    margin-bottom: 15px;
    @media screen and (max-width: 768px) {
      font-size: 19px;
      margin-bottom: 15px;
    }
  }
  > h3 {
    color: #555;
    font-style: italic;
  }
}

.profile {
  font-size: 13px;
  line-height: 1.6;
  font-weight: bold;
  text-align: left;
  margin: 0;
  color: #333;

  > h2 {
    font-size: 16px;
    margin: 0 0 5px 0;
  }

  > p {
    display: block;
    margin: 0 0 5px 0;
  }
}

.copyright {
  margin-top: 120px;
  letter-spacing: 2px;
  text-shadow: 1px 2px 3px #808080;
  pointer-events: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue